<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <v-expansion-panels multiple v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>META MENSUAL {{ monthGaugeSelected }}-{{ yearGaugeSelected }}</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="monthGaugeSelected"
                            :items="select.month"
                            item-value="id"
                            item-text="name"
                            label="Mes"
                            dense
                            outlined
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="yearGaugeSelected"
                            :items="select.year"
                            item-value="id"
                            item-text="name"
                            label="Año"
                            dense
                            outlined
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <!-- GAUGE -->
                        <v-col
                          cols="12"
                          md="7"
                        >
                          <v-card flat>
                            <v-card-text>
                              <highcharts :options="monthlyGoal"></highcharts>
                            </v-card-text>
                          </v-card>
                        </v-col>

                        <!-- VENTAS -->
                        <v-col
                          cols="12"
                          md="5"
                        >
                          <v-card
                            flat
                            outlined
                            class="pa-4"
                          >
                            <v-card-title class="pb-2">
                              <span class="text-h6">
                                Ventas del mes
                              </span>
                            </v-card-title>

                            <v-card-text>
                              <!-- TOTAL -->
                              <div class="text-center mb-6">
                                <div class="text-h2 font-weight-bold primary--text">
                                  {{ monthlySales.totalSales }}
                                </div>

                                <div class="grey--text text--darken-1">
                                  ventas realizadas
                                </div>
                              </div>

                              <v-divider class="mb-4"></v-divider>

                              <!-- WEB -->
                              <v-row align="center">
                                <v-col cols="8">
                                  <v-icon
                                    color="primary"
                                    class="mr-2"
                                  >
                                    mdi-web
                                  </v-icon>

                                  Ventas Web
                                </v-col>

                                <v-col
                                  cols="4"
                                  class="text-right font-weight-bold"
                                >
                                  {{ monthlySales.webSales }}
                                </v-col>
                              </v-row>

                              <!-- TIKTOK -->
                              <v-row align="center">
                                <v-col cols="8">
                                  <v-icon
                                    color="pink"
                                    class="mr-2"
                                  >
                                    mdi-music-note
                                  </v-icon>

                                  Ventas TikTok
                                </v-col>

                                <v-col
                                  cols="4"
                                  class="text-right font-weight-bold"
                                >
                                  {{ monthlySales.tiktokSales }}
                                </v-col>
                              </v-row>

                              <v-divider class="my-4"></v-divider>

                              <!-- PROMEDIO -->
                              <v-row align="center">
                                <v-col cols="8">
                                  <v-icon
                                    color="success"
                                    class="mr-2"
                                  >
                                    mdi-chart-line
                                  </v-icon>

                                  Promedio diario
                                </v-col>

                                <v-col
                                  cols="4"
                                  class="text-right"
                                >
                                  <span class="text-h6 font-weight-bold">
                                    {{ monthlySales.averagePerDay }}
                                  </span>

                                  <small class="grey--text">
                                    / día
                                  </small>
                                </v-col>
                              </v-row>

                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>

                      <v-row class="mt-4">
  <v-col cols="12">
    <v-card
      outlined
      flat
    >
      <v-card-title>
        <span class="text-h6">
          Resumen de ventas
        </span>

        <v-spacer></v-spacer>

        <v-btn
          color="primary"
          outlined
          small
          @click="showMonthlySalesDetail = !showMonthlySalesDetail"
        >
          <v-icon left>
            {{ showMonthlySalesDetail
              ? 'mdi-chevron-up'
              : 'mdi-chart-box-outline'
            }}
          </v-icon>

          {{ showMonthlySalesDetail
            ? 'Ocultar detalle'
            : 'Mostrar detallado'
          }}
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>

        <!-- RESUMEN -->
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-center">
                Total bolsitas
              </th>

              <th class="text-center">
                Bolsitas cerradas
              </th>

              <th class="text-center">
                Bolsitas pendientes
              </th>

              <th class="text-center">
                Ventas web
              </th>

              <th class="text-center">
                Total ventas
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td class="text-center">
                <span class="font-weight-bold text-h6">
                  {{ monthlySalesDetail.totalBolsitas }}
                </span>
              </td>

              <td class="text-center">
                <span class="font-weight-bold success--text text-h6">
                  {{ monthlySalesDetail.totalBolsitasCerradas }}
                </span>
              </td>

              <td class="text-center">
                <span class="font-weight-bold warning--text text-h6">
                  {{ monthlySalesDetail.totalBolsitasPendientes }}
                </span>
              </td>

              <td class="text-center">
                <span class="font-weight-bold primary--text text-h6">
                  {{ monthlySalesDetail.totalVentasWeb }}
                </span>
              </td>

              <td class="text-center">
                <span class="font-weight-bold text-h6">
                  {{ monthlySalesDetail.totalVentas }}
                </span>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <!-- DETALLE -->
        <v-expand-transition>
          <div
            v-show="showMonthlySalesDetail"
            class="mt-6"
          >
            <v-divider class="mb-4"></v-divider>

            <div class="text-subtitle-1 font-weight-bold mb-3">
              Detalle diario
            </div>

            <v-simple-table dense>
              <thead>
                <tr>
                  <th>
                    Fecha
                  </th>

                  <th class="text-center">
                    Total bolsitas
                  </th>

                  <th class="text-center">
                    Cerradas
                  </th>

                  <th class="text-center">
                    Pendientes
                  </th>

                  <th class="text-center">
                    Ventas web
                  </th>

                  <th class="text-center">
                    Total ventas
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="item in monthlySalesDaily"
                  :key="item.date"
                >
                  <td>
                    {{ formatDate(item.date) }}
                  </td>

                  <td class="text-center">
                    {{ item.totalBolsitas }}
                  </td>

                  <td class="text-center success--text font-weight-bold">
                    {{ item.totalBolsitasCerradas }}
                  </td>

                  <td class="text-center warning--text font-weight-bold">
                    {{ item.totalBolsitasPendientes }}
                  </td>

                  <td class="text-center primary--text font-weight-bold">
                    {{ item.totalVentasWeb }}
                  </td>

                  <td class="text-center font-weight-bold">
                    {{ item.totalVentas }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-expand-transition>

      </v-card-text>
    </v-card>
  </v-col>
</v-row>


                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>VENTAS DEL AÑO {{ year }}</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="year"
                            :items="select.year"
                            item-value="id"
                            item-text="name"
                            label="Año"
                            dense
                            outlined
                            @change="getMonthlySales"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <highcharts :options="chartOptions"></highcharts>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>VENTAS + BOLSITAS SIN CERRAR DEL AÑO {{ yearForSaleAndPartialSale }}</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="yearForSaleAndPartialSale"
                            :items="select.year"
                            item-value="id"
                            item-text="name"
                            label="Año"
                            dense
                            outlined
                            @change="getMonthlySalesAndPartialSales"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <highcharts :options="chartOptionsForSaleAndPartialSale"></highcharts>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>LOS {{top}} PRODUCTOS MÁS VENDIDOS DEL AÑO</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="top"
                            :items="select.top"
                            item-value="id"
                            item-text="name"
                            label="¿Cuantos productos desea ver?"
                            dense
                            outlined
                            @change="getBestSellingProducts"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <highcharts :options="lineChartOptions"></highcharts>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>{{ topD4 }} PRODUCTOS MÁS VENDIDOS DEL {{ monthD4 }}/{{ yearD4 }}</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="topD4"
                            :items="select.top"
                            item-value="id"
                            item-text="name"
                            label="¿Cuantos productos desea ver?"
                            dense
                            outlined
                            @change="bestSellingProductsPerMonth"
                          ></v-select>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="monthD4"
                            :items="select.month"
                            item-value="id"
                            item-text="name"
                            label="Año"
                            dense
                            outlined
                            @change="bestSellingProductsPerMonth"
                          ></v-select>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-select
                            v-model="yearD4"
                            :items="select.year"
                            item-value="id"
                            item-text="name"
                            label="¿Cuantos productos desea ver?"
                            dense
                            outlined
                            @change="bestSellingProductsPerMonth"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <highcharts :options="chartOptionsBestSellingProductsPerMonth"></highcharts>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </template>
        </div>
      </template>


      <template>
        <v-snackbar
          v-model="snackbar"
        >
          {{ text }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="pink"
              text
              v-bind="attrs"
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'
  import Highcharts from 'highcharts'
  import HighchartsMore from 'highcharts/highcharts-more'
  import { Chart } from 'highcharts-vue'

  HighchartsMore(Highcharts)

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  moment.locale('es');

  export default {
    name: 'DashboardView',
    components: {
      DefaultLayout,
      highcharts: Chart
    },
    data () {
      return {
        overlay: false,
        panel: [0, 1, 2, 3, 4],
        year: moment().format("YYYY"),
        yearForSaleAndPartialSale: moment().format("YYYY"),
        top: 5,
        topD4: 10,
        monthD4: moment().format("MM"),
        yearD4: moment().format("YYYY"),
        select: {
          year: [
            { id: '2021', name: '2021' },
            { id: '2022', name: '2022' },
            { id: '2023', name: '2023' },
            { id: '2024', name: '2024' },
            { id: '2025', name: '2025' },
            { id: '2026', name: '2026' }
          ],
          top: [
            { id: 5, name: '5' },
            { id: 10, name: '10' },
            { id: 15, name: '15' },
            { id: 20, name: '20' }
          ],
          month: [
            { id: '01', name: 'ENERO' },
            { id: '02', name: 'FEBRERO' },
            { id: '03', name: 'MARZO' },
            { id: '04', name: 'ABRIL' },
            { id: '05', name: 'MAYO' },
            { id: '06', name: 'JUNIO' },
            { id: '07', name: 'JULIO' },
            { id: '08', name: 'AGOSTO' },
            { id: '09', name: 'SEPTIEMBRE' },
            { id: '10', name: 'OCTUBRE' },
            { id: '11', name: 'NOVIEMBRE' },
            { id: '12', name: 'DICIEMBRE' }
          ]
        },
        showMonthlySalesDetail: false,
        monthlySalesDetail: {
          totalBolsitas: 0,
          totalBolsitasCerradas: 0,
          totalBolsitasPendientes: 0,
          totalVentasWeb: 0,
          totalVentas: 0
        },
        monthlySalesDaily: [],
        hoy: moment().format("DD MMMM YYYY"),
        monthlySales: {
          year: null,
          month: null,
          tiktokSales: 0,
          webSales: 0,
          totalSales: 0,
          daysInMonth: 0,
          averagePerDay: 0
        },
        monthlyTarget: 6750,
        monthlyNetProfit: 0,
        monthGaugeSelected: moment().format("MM"),
        yearGaugeSelected: moment().format("YYYY"),
        monthlyGoal: {
          chart: {
            type: 'gauge',
            backgroundColor: 'transparent',
            height: 300,
            style: {
              fontFamily: 'Roboto, sans-serif'
            }
          },

          title: {
            text: 'GANANCIA NETA MENSUAL',
            style: {
              fontSize: '18px',
              fontWeight: '500',
              color: '#424242'
            }
          },

          pane: {
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '78%'],
            size: '100%',
            background: null
          },

          yAxis: {
            min: 0,
            max: 30000,

            lineWidth: 0,
            tickWidth: 0,
            minorTickInterval: null,

            labels: {
              distance: 18,

              style: {
                fontSize: '11px',
                color: '#757575'
              },

              formatter: function () {
                return 'S/' + Highcharts.numberFormat(this.value, 0);
              }
            },

            plotBands: [
              {
                from: 0,
                to: 15000,
                color: '#EF5350',
                thickness: 28
              },
              {
                from: 15000,
                to: 22500,
                color: '#FFCA28',
                thickness: 28
              },
              {
                from: 22500,
                to: 30000,
                color: '#66BB6A',
                thickness: 28
              }
            ]
          },

          tooltip: {
            enabled: false
          },

          series: [
            {
              name: 'Ganancia neta',

              data: [22500],

              dial: {
                radius: '72%',
                backgroundColor: '#424242',
                baseWidth: 9,
                topWidth: 3,
                baseLength: '0%',
                rearLength: '0%'
              },

              pivot: {
                radius: 8,
                backgroundColor: '#424242'
              },

              dataLabels: {
                borderWidth: 0,

                y: 35,

                style: {
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '24px',
                  fontWeight: '500',
                  color: '#212121'
                },

                format: 'S/.{y:,.2f}'
              }
            }
          ],

          credits: {
            enabled: false
          }
        },
        chartOptions: {
          chart: {
            type: 'column'
          },
          title: {
            text: 'VENTAS DEL AÑO'
          },
          xAxis: {
            type: 'category'
          },
          yAxis: {
            title: {
              text: `total ventas en S/.`
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: 'S/.{point.y:.1f}'
              }
            }
          },
          series: [{
            name: 'Ventas',
            colorByPoint: true,
            data: []
          }]
        },
        chartOptionsForSaleAndPartialSale: {
          chart: {
            type: 'column'
          },
          title: {
            text: 'VENTAS + BOLSITAS SIN CERRAR<br>DEL AÑO'
          },
          xAxis: {
            type: 'category'
          },
          yAxis: {
            title: {
              text: `total ventas en S/.`
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: 'S/.{point.y:.1f}'
              }
            }
          },
          series: [{
            name: 'Ventas',
            colorByPoint: true,
            data: []
          }]
        },
        lineChartOptions: {
          chart: {
            type: 'line'
          },
          title: {
              text: 'Productos con más ventas',
              align: 'left'
          },

          subtitle: {
              text: 'Visualizar: <a href="https://admin.dino-toys.com/#/manage/product" target="_blank">PRODUCTOS</a>.',
              align: 'left'
          },

          yAxis: {
              title: {
                  text: 'Cantidad vendida'
              }
          },

          xAxis: {
              categories: [
                  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                  'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'
              ],
              accessibility: {
                  description: 'Months of the year'
              }
          },

          legend: {
              layout: 'vertical',
              align: 'right',
              verticalAlign: 'middle'
          },

          tooltip: {
              crosshairs: true,
              shared: true
          },

          plotOptions: {
              spline: {
                  marker: {
                      radius: 4,
                      lineColor: '#666666',
                      lineWidth: 1
                  }
              }
          },

          series: [],

          responsive: {
              rules: [{
                  condition: {
                      maxWidth: 500
                  },
                  chartOptions: {
                      legend: {
                          layout: 'horizontal',
                          align: 'center',
                          verticalAlign: 'bottom'
                      }
                  }
              }]
          }
        },
        chartOptionsBestSellingProductsPerMonth: {
          chart: {
            type: 'column'
          },
          title: {
            text: 'VENTAS DEL AÑO'
          },
          xAxis: {
            type: 'category'
          },
          yAxis: {
            title: {
              text: `unidades`
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          series: [{
            name: 'Ventas',
            colorByPoint: true,
            data: []
          }]
        },
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      getMonthlySalesDetail: function () {
        this.overlay = true;

        axios.get(process.env.DINO.PATH.GET_SALES_MONTHLY_DETAIL, {
          params: {
            year: this.yearGaugeSelected,
            month: this.monthGaugeSelected
          }
        })
        .then(response => {
          this.monthlySalesDetail = response.data.summary;
          this.monthlySalesDaily = response.data.detail;
        })
        .catch(error => {
          console.error(error);

          this.showMessage(
            'Hubo un problema obteniendo el detalle de ventas',
            'red'
          );
        })
        .then(() => {
          this.overlay = false;
        });
      },

      formatDate(date) {
        if (!date) {
          return '';
        }

        const parts = date.split('-');

        if (parts.length !== 3) {
          return date;
        }

        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      },

      getMonthlyNetProfit: function () {
        this.overlay = true;

        axios.get(process.env.DINO.PATH.GET_MONTHLY_NET_PROFIT, {
          params: {
            year: this.yearGaugeSelected,
            month: this.monthGaugeSelected
          }
        })
        .then(response => {
          this.monthlyNetProfit = Number(response.data.netProfit || 0);

          this.updateMonthlyGoalChart();
        })
        .catch(error => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      updateMonthlyGoalChart() {
        const target = this.monthlyTarget;

        this.monthlyGoal.yAxis.max = target;

        this.monthlyGoal.yAxis.plotBands = [
          {
            from: 0,
            to: target * 0.50,
            color: '#EF5350',
            thickness: 28
          },
          {
            from: target * 0.50,
            to: target * 0.75,
            color: '#FFCA28',
            thickness: 28
          },
          {
            from: target * 0.75,
            to: target,
            color: '#66BB6A',
            thickness: 28
          }
        ];

        this.monthlyGoal.series[0].data = [
          this.monthlyNetProfit
        ];
      },

      getBannerMonthlySales: function () {
        axios.get(process.env.DINO.PATH.GET_BANNER_MONTHLY_SALES, {
          params: {
            year: this.yearGaugeSelected,
            month: this.monthGaugeSelected
          }
        })
        .then(response => {
          this.monthlySales = response.data;
        })
        .catch(error => {
          this.showMessage(
            'Hubo un problema obteniendo las ventas mensuales',
            'red'
          );
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getMonthlySales: function () {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.MONTHLY_SALES_LISTS.replace(':year', this.year))
        .then(response => {
          let list = [];
          response.data.forEach((value, index) => {
            list.push({'y': value.total, 'name': moment(value.created_at).format("MMMM")});
          });
          this.chartOptions.series[0].data = list;
        })
        .catch(error => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getMonthlySalesAndPartialSales: function () {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.MONTHLY_SALES_AND_PARTIAL_SALES_LISTS.replace(':year', this.yearForSaleAndPartialSale))
        .then(response => {
          let list = [];
          response.data.forEach((value, index) => {
            list.push({'y': value.total, 'name': moment(value.created_at).format("MMMM")});
          });
          this.chartOptionsForSaleAndPartialSale.series[0].data = list;
        })
        .catch(error => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      getBestSellingProducts: function () {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.GET_BEST_SELLING_PRODUCTS.replace(':top', this.top))
        .then(response => {
          this.lineChartOptions.series = response.data;
        })
        .catch(error => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      bestSellingProductsPerMonth: function () {
        this.overlay = true;
        axios.get(
          process.env.DINO.PATH.GET_BEST_SELLING_PRODUCTS_PER_MONTH
            .replace(':year', this.yearD4)
            .replace(':month', this.monthD4)
            .replace(':top', this.topD4)
          )
        .then(response => {
          let list = [];
          response.data.forEach((value, index) => {
            list.push({
              'y': Number(value['order_detail.quantity_units_product']), 
              'name': value['order_detail.product.name']
            });
          });

          this.chartOptionsBestSellingProductsPerMonth.series[0].data = list;
        })
        .catch(error => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      logout: function() {
        localStorage.clear();
        window.location.href = "/";
      }
    },

    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.getMonthlyNetProfit();
      this.getBannerMonthlySales();
      this.getMonthlySales();
      this.getBestSellingProducts();
      this.getMonthlySalesAndPartialSales();
      this.bestSellingProductsPerMonth();
      this.getMonthlySalesDetail();
    },

    watch: {
      monthGaugeSelected () {
        if (this.monthGaugeSelected && this.yearGaugeSelected) {
          this.getMonthlyNetProfit();
          this.getBannerMonthlySales();
          this.getMonthlySalesDetail();
        }
      },

      yearGaugeSelected () {
        if (this.monthGaugeSelected && this.yearGaugeSelected) {
          this.getMonthlyNetProfit();
          this.getBannerMonthlySales();
          this.getMonthlySalesDetail();
        }
      }
    },
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue